import { render, staticRenderFns } from "./wsBusinessServiceKeySelect.vue?vue&type=template&id=15141ef3&scoped=true&"
import script from "./wsBusinessServiceKeySelect.vue?vue&type=script&lang=js&"
export * from "./wsBusinessServiceKeySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15141ef3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
